import { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  message,
  Row,
  Col,
  DatePicker,
  Select,
} from "antd";
import Moment from "react-moment";
import moment from "moment";
import { MdCheck } from "react-icons/md";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleScheduleBooking } from "../../../apis/bookings";
import fetchData from "../../../services/fetchData";
import { handleFetchSites } from "../../../apis/sites";
const { Option } = Select;

export default function RescheduleBooking({
  isVisible,
  selected,
  setVisible,
}: any) {
  const [selectedUnit, setSelectedUnit] = useState<any>(null);
  const [slotModal, setSlotModal] = useState(false);
  const [date, setDate] = useState<any>(null);
  const [slot, setSlot] = useState<any>(null);
  const [units, setUnits] = useState<any>([]);
  const [site, setSite] = useState<any>(null);
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const { data: sites } = useQuery({
    queryKey: ["sites"],
    queryFn: handleFetchSites,
  });

  const onChangeSite = async (event: any) => {
    if (!date) return;
    const uri = `v1/slots?site=${event}&date=${date}`;
    const response = await fetchData({ uri });
    setSite(event);
    setUnits(response?.units);
  };

  const onChangeDate = async (event: any) => {
    const fdate = moment(new Date(event)).format("YYYYMMDD");
    if (site === undefined) return;
    if (fdate === "Invalid date") return;
    const uri = `v1/slots?site=${site}&date=${fdate}`;
    setDate(fdate);
    setSelectedUnit(null);
    const response = await fetchData({ uri });
    setSlot(response);
    setUnits(response?.units);
  };

  const { mutate: rescheduleBooking, isPending } = useMutation({
    mutationFn: handleScheduleBooking,
    onSuccess: () => {
      message.success("Rescheduled Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
      queryClient.invalidateQueries({ queryKey: ["allCount"] });
      queryClient.invalidateQueries({ queryKey: ["pendingCount"] });
      queryClient.invalidateQueries({ queryKey: ["confirmedCount"] });
      queryClient.invalidateQueries({ queryKey: ["fulfilledCount"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const handleHideModal = () => {
    setSlotModal(false);
  };

  const onSubmit = async () => {
    const data = {
      date: moment(date).format("YYYY-MM-DD"),
      slot: slot?._id,
      unit: selectedUnit?._id,
      site: site,
      startTime: selectedUnit?.startTime,
      endTime: selectedUnit?.endTime,
    };

    await rescheduleBooking({ data, _id: selected?._id });
  };

  const siteOptions = sites?.records?.map((site: any, index: number) => (
    <Option key={index} value={site?._id}>
      {site?.name}
    </Option>
  ));

  const hideModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ site: selected?.site?._id });
    setDate(null);
    setSelectedUnit(null);
    setSite(selected?.site?._id);
  }, [selected, isVisible]);

  return (
    <Modal
      open={isVisible}
      title="Reschedule Booking"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="rescheduleBooking"
          htmlType="submit"
          danger
          type="primary"
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
    >
      <Form
        id="rescheduleBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout={"vertical"}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="mb-4">Booking No. {selected?.bookingNo}</div>
          <div className="flex justify-between items-center">
            <div className="">
              <div className="flex ">
                <span className="w-12">Date: </span>
                <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
              </div>
              <div className="flex ">
                <span className="w-12">Time : </span>
                <Moment format="HH:mm A">{selected?.startTime}</Moment>
                <div className="mx-2">-</div>
                <Moment format="HH:mm A">{selected?.endTime}</Moment>
              </div>
            </div>
            <div className="">To</div>
            <div className="text-green-600">
              <div className="flex ">
                <span className="w-12">Date: </span>
                {date ? <Moment format="Do MMM, YYYY">{date}</Moment> : null}
              </div>
              <div className="flex ">
                <span className="w-12">Time : </span>
                {selectedUnit ? (
                  <>
                    <Moment format="HH:mm A">{selectedUnit?.startTime}</Moment>
                    <div className="mx-2">-</div>
                    <Moment format="HH:mm A">{selectedUnit?.endTime}</Moment>
                  </>
                ) : (
                  <>
                    <div className="w-32"></div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="site"
              label="Site"
              initialValue={selected?.site?._id}
              rules={[
                {
                  required: true,
                  message: "Please select site",
                },
              ]}
            >
              <Select placeholder="Select Site" onChange={onChangeSite}>
                {siteOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                format={"Do MMM, YYYY"}
                onChange={onChangeDate}
                className="w-full"
              />
            </Form.Item>
          </Col>
          {date ? (
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="time"
                label="Time"
                rules={[
                  {
                    required: false,
                    message: "Please select time",
                  },
                ]}
              >
                {selectedUnit ? (
                  <div
                    className="border p-1 w-full px-2 text-black"
                    onClick={() => setSlotModal(true)}
                  >
                    {moment(selectedUnit?.startTime).format("HH:mm")}
                    {" - "}
                    {moment(selectedUnit?.endTime).format("HH:mm")}
                  </div>
                ) : (
                  <div
                    onClick={() => setSlotModal(true)}
                    className="border p-1 w-full px-2 text-gray-400 hover:cursor-pointer"
                  >
                    Time
                  </div>
                )}
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>

      <Modal
        open={slotModal}
        title={`Booking Slots :  ${moment(date).format("Do MMM, YYYY")}`}
        onCancel={handleHideModal}
        footer={false}
      >
        {units?.map((unit: any, index: number) => (
          <div
            className="flex justify-between items-center border-t py-2"
            key={index}
            onClick={() => {
              if (unit?.limit - unit?.bookings?.length < 1) return;
              setSelectedUnit(unit);
              setSlotModal(false);
            }}
          >
            <div className="flex">
              <div className="mr-2">{index + 1}.</div>
              <div className="flex ml-4">
                <span style={{ color: "#323232" }}>
                  {moment(unit?.startTime).format("HH:mm")}
                </span>
                <span className="mx-4">-</span>
                <span style={{ color: "#323232" }}>
                  {moment(unit?.endTime).format("HH:mm")}
                </span>
              </div>
            </div>
            <div className="flex justify-center items-center ml-4">
              {unit?.bookings?.length >= unit?.limit ? (
                <div className="bg-gray-100 w-56 px-2 py-1 mr-4">
                  <span className="mx-2 text-gray-400">Fully Booked </span>
                </div>
              ) : (
                <div className="bg-gray-100 w-56 px-2 py-1 mr-4 text-green-600">
                  <span className="">
                    {unit?.limit - unit?.bookings?.length}
                  </span>
                  <span className="mx-2">slot available</span>
                </div>
              )}

              <div
                className={`h-8 w-8 border flex justify-center items-center ${
                  unit?.bookings?.length >= unit?.limit
                    ? "border-gray-200"
                    : "border-green-500 "
                } `}
              >
                {selectedUnit?._id === unit?._id ? (
                  <MdCheck size={15} color="green" />
                ) : (
                  <div className=""></div>
                )}
              </div>
            </div>
          </div>
        ))}
      </Modal>
    </Modal>
  );
}
